(function () {
  'use strict';

  function initContact(section) {
    if (!section || section.dataset.auraaContactInit === 'true') return;
    section.dataset.auraaContactInit = 'true';

    var message = section.querySelector('[data-auraa-message]');
    var counter = section.querySelector('[data-auraa-count]');
    var form = section.querySelector('form');
    var submit = section.querySelector('[data-auraa-submit]');
    var submitText = section.querySelector('[data-auraa-submit-text]');
    var success = section.querySelector('[data-auraa-contact-success]');
    var revealItems = section.querySelectorAll('[data-auraa-reveal]');

    function updateCount() {
      if (!message || !counter) return;
      var max = Number(message.getAttribute('maxlength')) || 600;
      counter.textContent = message.value.length + ' / ' + max;
    }

    if (message) {
      updateCount();
      message.addEventListener('input', updateCount);
    }

    if (form && submit) {
      form.addEventListener('submit', function () {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (submitText) submitText.textContent = 'SENDING';
      });
    }

    if (success) {
      window.setTimeout(function () {
        success.focus({ preventScroll: true });
      }, 100);
    }

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-auraa-contact]').forEach(initContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches && event.target.matches('[data-auraa-contact]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-auraa-contact]');

    if (section) initContact(section);
  });
})();